import React from 'react';

const cities = [
  'Newport Beach', 'Irvine', 'Laguna Beach', 'Laguna Niguel',
  'Dana Point', 'Mission Viejo', 'Lake Forest', 'Tustin',
  'Anaheim', 'Orange', 'Santa Ana', 'Costa Mesa',
  'Garden Grove', 'Huntington Beach', 'Aliso Viejo', 'Rancho Santa Margarita',
];

export default function ServiceArea() {
  return (
    <section style={{ padding: '120px 0', background: 'var(--mamba-graphite)' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <div className="label-gold mb-4 reveal">
              <span style={{ width: '32px', height: '1px', background: 'var(--mamba-gold-light)', display: 'inline-block' }} />
              Service Area
            </div>
            <h2
              className="section-heading reveal reveal-delay-1"
              style={{ fontSize: 'clamp(30px, 3.5vw, 48px)', marginBottom: '16px' }}
            >
              Wherever you are<br />
              <span className="text-gradient-purple">in Orange County, we're there.</span>
            </h2>
            <p className="reveal reveal-delay-2" style={{ color: 'var(--gray-dim)', fontSize: '16px', lineHeight: '1.7', fontFamily: 'DM Sans, sans-serif', marginBottom: '32px' }}>
              DA1MAMBA brings the detail shop to your driveway, office parking lot, or anywhere that works for you — no drop-off, no waiting, no hassle. Just send us your address and we handle the rest.
            </p>
            <div className="reveal reveal-delay-3" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              {['Newport Beach', 'Irvine', 'Orange County']?.map((city) => (
                <span
                  key={city}
                  style={{
                    background: 'rgba(107,33,168,0.15)',
                    border: '1px solid rgba(107,33,168,0.35)',
                    color: 'var(--mamba-purple-bright)',
                    fontFamily: 'Manrope, sans-serif',
                    fontWeight: 700,
                    fontSize: '12px',
                    letterSpacing: '0.06em',
                    textTransform: 'uppercase',
                    padding: '8px 16px',
                  }}
                >
                  {city}
                </span>
              ))}
            </div>
          </div>

          {/* Right — City grid */}
          <div className="reveal reveal-delay-2">
            <div
              style={{
                background: 'var(--mamba-graphite-mid)',
                border: '1px solid rgba(107,33,168,0.2)',
                padding: '32px',
              }}
            >
              <div className="label-gold mb-5" style={{ fontSize: '10px' }}>Cities We Serve</div>
              <div className="grid grid-cols-2 gap-y-3 gap-x-6">
                {cities?.map((city) => (
                  <div key={city} className="flex items-center gap-2">
                    <div style={{ width: '5px', height: '5px', borderRadius: '50%', background: 'var(--mamba-gold-light)', flexShrink: 0 }} />
                    <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '14px', color: 'var(--cool-gray)' }}>
                      {city}
                    </span>
                  </div>
                ))}
              </div>
              <div
                style={{
                  marginTop: '24px',
                  paddingTop: '20px',
                  borderTop: '1px solid rgba(107,33,168,0.15)',
                  color: 'var(--gray-dim)',
                  fontSize: '13px',
                  fontFamily: 'DM Sans, sans-serif',
                }}
              >
                + All surrounding Orange County cities
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
